import { createRouter, createWebHistory } from 'vue-router';
import Home from '@/views/Home.vue';
import About from '@/views/About.vue';
/** @Account */
import Login from '@/views/Account/Login.vue';
import Signup from '@/views/Account/Signup.vue';
import SignupPassword from '@/views/Account/SignupPassword.vue';
import ResetPassword from '@/views/Account/ResetPassword.vue';
import ForgotPassword from '@/views/Account/ForgotPassword.vue';
/** @Order */
import Order from '@/views/Order.vue';
/** @Request */
import Request from '@/views/Request.vue';
/** @Setting */
import Setting from '@/views/Setting.vue';
/** @history */
import History from '@/views/History.vue';
/** @demandReservationSearch */
import DemandReservationSearch from '@/views/DemandReservationSearch.vue';
/** @chat */
import Chat from '@/views/Chat.vue';
/** @threads */
import Threads from '@/views/Threads.vue';

/** @Driver */

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      name: 'Home',
      label: 'ホーム',
      acceptRole: [11, 13],
    },
  },
  {
    path: '/order',
    name: 'Order',
    component: Order,
    meta: {
      name: 'Order',
      label: '予約一覧',
      acceptRole: [11, 13],
    },
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: {
      name: 'About',
      label: '概要',
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup,
    children: [
      {
        path: '/signup/password',
        name: 'signup/password',
        component: SignupPassword,
      },
    ],
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: {
      name: 'ForgotPassword',
      label: 'パスワード再発行',
    },
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: {
      name: 'ResetPassword',
      label: 'パスワード再設定',
    },
  },
  {
    path: '/request',
    name: 'Request',
    component: Request,
    meta: {
      name: 'Request',
      label: '配車依頼',
      acceptRole: [11, 13],
    },
  },
  {
    path: '/setting',
    name: 'Setting',
    component: Setting,
    meta: {
      name: 'Setting',
      label: '設定',
      acceptRole: [11, 13],
    },
  },
  {
    path: '/history',
    name: 'History',
    component: History,
    meta: {
      name: 'History',
      label: '履歴',
      acceptRole: [11, 13],
    },
  },
  {
    path: '/demandReservationSearch',
    name: 'DemandReservationSearch',
    component: DemandReservationSearch,
    meta: {
      name: 'DemandReservationSearch',
      label: 'デマンド予約確認',
      acceptRole: [11, 13],
    },
  },
  {
    path: '/chat/:reservationId/:userId',
    name: 'Chat',
    component: Chat,
    meta: {
      name: 'Chat',
      label: 'チャット',
      acceptRole: [11, 13],
    },
  },
  {
    path: '/threads',
    name: 'Threads',
    component: Threads,
    meta: {
      name: 'Threads',
      label: 'スレッド',
      acceptRole: [11, 13],
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
